import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { useHandlingFee } from "../../../../context/HandlingFeeContext";
import { useGetAgentFeeLevelBonus } from "../../../../hooks/handlingfeereport.hooks";
import styles from "./style.module.scss";

const Level = ({ level = null }) => {
  const { t } = useTranslation();
  const nowCurrency = getCurrency();
  const { selectedMonth } = useHandlingFee();
  const { data, isLoading, isError } = useGetAgentFeeLevelBonus({
    params: {
      period_month: selectedMonth.value,
      level: level,
    },
    options: {
      enabled: level !== null && selectedMonth !== null,
    },
  });

  const columns = [
    {
      title: t("comission.table.account"),
      width: 100,
      align: "center",
      dataIndex: "account",
    },

    {
      title: t("comission.table.UID"),
      width: 100,
      align: "center",
      dataIndex: "account_id",
    },
    {
      title: t("comission.table.levelBonus") + `(${t(`global.currency.${nowCurrency}`)})`,
      width: 100,
      align: "center",
      dataIndex: "level_fee_bonus_amount",
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      {isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={data?.bonus_detail || []}
          showInifineScroll={false}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} />
                  <Table.Summary.Cell index={2}>
                    <div
                      className={`${styles.summaryCell} ${styles.content} ${
                        data?.total_bonus <= 0 ? styles.redColor : styles.greenColor
                      }`}
                    >
                      {moneyFormat(data?.total_bonus || 0)}
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} />
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
    </div>
  );
};

export default Level;
